import React from 'react';
import {LoginUsername, TestConnection, errorLogin, checkDomain} from '../actions'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import arrow from "../build/images/icon_arrow_right.svg"
import ErrorMessage from '../containers/ErrorMessage';
import { connection_platform } from '../services/api';

var i = 1;

// Solicita a permissão para realizar as notificações
document.addEventListener('DOMContentLoaded', function () {
  if (Notification.permission !== "granted")
    Notification.requestPermission();
  });
  // Função para exibir as notificações
  function NofiticacaoGoogleChrome() {
  if (!Notification) {
  alert('Notificações de área de trabalho que não estão disponíveis no seu navegador. Tente com o navegador Google Chrome');
  return;
  }
  
  if (Notification.permission !== "granted")
  Notification.requestPermission();
  else {
  var notification = new Notification('Notificação IngWeb', {
  icon: 'https://cdn3.iconfinder.com/data/icons/ose/Warning.png',
  body: "Notificação Navegador",
  });
  
  notification.onclick = function () {
  window.open("http://site.com.br/pagina.html");
  };
  
  }
  
  }

function spawnNotification(opcoes) {
  var n = new Notification(opcoes.title, opcoes.opt);
  if (opcoes.link !== '') {
      n.addEventListener("click", function() {               
          n.close();
          window.focus();
          window.location.href = opcoes.link;
      });
  }
}

const mapDispatchToProps = dispatch => {
  return {
    TestConection: post => {
      dispatch(TestConnection(post));
    },
    onAddPost: post => {
      dispatch(LoginUsername(post));
    },
    checkDomain: (domain,login) => {
      dispatch(checkDomain(domain,login));
    },
    errorLogin: (post,post1,post2) => {
      dispatch(errorLogin(post,post1,post2));
    }
  };
};

const mapStateToProps = (state) => {
  return {
    VerificarID: state.informationusers
  };
}

class Login extends React.Component {
  
  state = {
    email: ''
  };

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  componentDidMount(){
    this.props.TestConection();
    localStorage.setItem('info_login', 'useroff');
    // MicroModal.show('modal-component-edit-evaluation-modal');
  }

  componentWillUnmount(){
    clearInterval(this.state);
    clearInterval(this.props);
  }

  handleSubmit = e => {
    e.preventDefault();
    if(connection_platform.isOrganization === true){
      if (this.state.email.trim()) {
        let domain = this.state.email.lastIndexOf('@');
        if(domain !== -1){
          this.props.checkDomain(this.state.email.substring(domain),this.state.email);
        }else{
          this.props.errorLogin(null,null,'ON1')
        }
      }
    }else{
      if (this.state.email.trim()) {
        this.props.onAddPost(this.state);
      }
    }
  };

  handleBlock = e => {
  //   i = i+1;
  //  document.title = '('+i+') Ingweb'
  }

  render() {
    const {VerificarID} = this.props;
    const box = [];

    let message = ''

    if (VerificarID.length !== 0 && VerificarID.error === undefined && VerificarID.error !== true){


      if(VerificarID.force_password_change){
        return <Redirect to='/changepassword' />
      }else{
        return <Redirect to='/senha' />
      }


    }
        

    if(VerificarID.error && VerificarID.server === 'OFF'){
        box.push("is-invalid");
        message = 'Usuário não existe';
    }

    if(VerificarID.error && VerificarID.server === 'ON1'){
      box.push("is-invalid");
      message = 'Email inválido';
    }

    if(VerificarID.error && VerificarID.server === 'ON2'){
      box.push("is-invalid");
      message = 'Domínio Inexistente';
    }
    
    if(VerificarID.error && VerificarID.server === 'ON'){
        box.push("is-invalid");
        message = 'Nenhum servidor cadastrado';
    }

    return (
      <div className="login">
        <div className={connection_platform.class_image_login}>
          {/* <h1>IngWeb</h1>
          <p>Otimizador de centros de atendimentos</p> */}
        </div>
        <div className="col-form">
          <div className="block no-round">
              <div className="block-content">
                  <form  onSubmit={ this.handleSubmit } name="form_login" className="row justify-content-md-center" id="form_login">
                    <div className="form-group">
                        <h2>Seja Bem-vindo!</h2>
                        <p>Entre com seu usuário</p>
                    </div>
                    <div className="form-group">
                        <input required className={box.join('' )} autoFocus={true} ref={c => (this._inputEmail = c)} type="text" name="email" id="email" placeholder="Usuário" value={ this.state.email } onChange={ this.handleInputChange }/>
                        <div className="invalid-feedback">{message}</div>
                    </div>
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary btn-hero btn-small pull-right">Próximo <img alt="arrow" src={arrow} width="8" /></button>
                    </div>
                  </form>
              </div>
          </div>
        </div>
        <ErrorMessage/>
    </div>
    );
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login);